module.exports = __webpack_public_path__ + "static/images/components/Reserve/images/bg.8f1a287d.png";


//////////////////
// WEBPACK FOOTER
// ./components/Reserve/images/bg.png
// module id = 2661
// module chunks = 11